/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, imageTypes, replacePXinStringWithEM, animations } from 'utils/styles';
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// REWARD : GIFTCARD STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
    giftcard: {
        cursor: 'pointer',
        display: 'inline-block',
        boxShadow: replacePXinStringWithEM('0 0 22px 0 #ffc566'),
        '&.amazon': {
            extend: imageTypes.photo,
            backgroundImage: `url(${url.image.app}/graphic-giftcard-amazon.png)`,
            width: pxToEm(70), //278
            height: pxToEm(44), //174
            borderRadius: pxToEm(2)
        },
        '&.generic': {
            extend: imageTypes.card,
            backgroundImage: `url(${url.image.app}/graphic-giftcard-generic.png)`,
            width: pxToEm(65),
            height: pxToEm(44),
            borderRadius: pxToEm(3),
            marginBottom: pxToEm(10),
            boxShadow: 'none'
        },
        '&.amazonstars': {
            extend: imageTypes.photo,
            backgroundImage: `url(${url.image.app}/graphic-giftcard-amazon-stars.png)`,
            boxShadow: `none`,
            width: pxToEm(75),
            height: pxToEm(50),
            fontSize: '150%'
        },
        '&.genericstars': {
            extend: imageTypes.photo,
            backgroundImage: `url(${url.image.app}/graphic-giftcard-generic-stars.png)`,
            boxShadow: `none`,
            width: pxToEm(75),
            height: pxToEm(50),
            fontSize: '150%'
        },
        // '&.rewardAvailable-true:hover' : {
        '&:hover': {
            extend: animations.imageHover
        }
    }
};